import React, { useEffect, useState } from 'react'
import { FormGroup, FormHelperText } from '@mui/material'
import SiteLinks from '../../siteLinks'
import { ProductApi } from '../../../api/productApi'
import { CategoryApi } from '../../../api/categoryApi'
import { PageApi } from '../../../api/pageApi'
import CategoryIcon from '@mui/icons-material/Category'
import PageIcon from '@mui/icons-material/MenuBook'
import ProductIcon from '@mui/icons-material/Ballot'
import useTranslation from '../../../hooks/useTranslation'

export default function BannerSlideLinkPicker({ slide, onChange }) {
  const { t } = useTranslation()
  const [urlOptions, setUrlOptions] = useState({
    Category: [],
    Product: [],
    Page: [],
  })
  const [search, setSearch] = useState('')
  const [filteredOptions, setFilteredOptions] = useState([])
  const [nestedMenu, setNestedMenu] = useState(false)
  const [currentUrlOptions, setCurrentUrlOptions] = useState([])
  const [selectedModule, setSelectedModule] = useState(slide.urlModuleName || '')
  const [showOptions, setShowOptions] = useState(false)
  const [selectedModuleOption, setSelectedModuleOption] = useState({
    label: slide.urlModuleName ? slide.urlResourceName : slide.url,
    value: slide.url || '',
    module_name: slide.urlModuleName || '',
  })

  const fetchProducts = async () => {
    const res = await ProductApi.getProducts({ visible: true })
    return res?.data?.data || []
  }

  const fetchCategories = async () => {
    const res = await CategoryApi.getCategories({ visible: true })
    return res?.data?.data || []
  }

  const fetchPages = async () => {
    const res = await PageApi.getPages({ visible: true })
    return res?.data?.data || []
  }

  useEffect(() => {
    Promise.all([fetchCategories(), fetchProducts(), fetchPages()]).then((values) => {
      const nextOptions = {
        Category: values[0] || [],
        Product: values[1] || [],
        Page: values[2] || [],
      }
      setUrlOptions(nextOptions)
      resetDefaultOptions(nextOptions)
    })
  }, [])

  useEffect(() => {
    setSelectedModuleOption({
      label: slide.urlModuleName ? slide.urlResourceName : slide.url,
      value: slide.url || '',
      module_name: slide.urlModuleName || '',
    })
    setSelectedModule(slide.urlModuleName || '')
  }, [slide.url, slide.urlModuleName, slide.urlResourceName])

  const resetDefaultOptions = (options = urlOptions) => {
    setCurrentUrlOptions(
      Object.keys(options).map((option) => ({
        label: option,
        value: option,
        image:
          option === 'Category' ? (
            <CategoryIcon />
          ) : option === 'Product' ? (
            <ProductIcon />
          ) : (
            <PageIcon />
          ),
      }))
    )
  }

  const setProducts = () => {
    setCurrentUrlOptions(
      (urlOptions.Product || []).map((product) => ({
        label: product.name,
        value: `/${product.category_slug}/${product.slug}`,
        image:
          Array.isArray(product.images) && product.images.length > 0
            ? product.images[0].image
            : null,
      }))
    )
  }

  const setCategories = () => {
    setCurrentUrlOptions(
      (urlOptions.Category || []).map((category) => ({
        label: category.name,
        value: `/${category.slug}`,
        image: category.image || null,
      }))
    )
  }

  const setPages = () => {
    setCurrentUrlOptions(
      (urlOptions.Page || []).map((page) => ({
        label: page.name,
        value: `/pages/${page.slug}`,
      }))
    )
  }

  const listBackButtonOnClick = () => {
    setNestedMenu(false)
    setSearch('')
    setFilteredOptions([])
    resetDefaultOptions()
  }

  const handleOnListClicked = (event) => {
    if (!nestedMenu) {
      const option = event.target.dataset.value

      if (option === 'Product') {
        setProducts()
      } else if (option === 'Category') {
        setCategories()
      } else if (option === 'Page') {
        setPages()
      }

      setNestedMenu(true)
      setSearch('')
      setSelectedModule(option)
      return
    }

    const nextValue = event.target.dataset.value || ''
    const nextLabel = event.target.innerText || ''

    setShowOptions(false)
    setSelectedModuleOption({
      label: nextLabel,
      value: nextValue,
      module_name: selectedModule,
    })

    onChange({
      url: nextValue,
      urlResourceName: nextLabel,
      urlModuleName: selectedModule,
    })
  }

  const urlOnChange = (event) => {
    const nextValue = event.target.value

    setSelectedModuleOption({
      label: nextValue,
      value: nextValue,
      module_name: '',
    })

    onChange({
      url: nextValue,
      urlResourceName: nextValue,
      urlModuleName: '',
    })
  }

  const searchOnChange = (event) => {
    const value = event.target.value
    setSearch(value)

    if (!value) {
      setFilteredOptions([])
      return
    }

    setFilteredOptions(
      currentUrlOptions.filter((option) =>
        String(option.value || '').toLowerCase().includes(value.toLowerCase())
      )
    )
  }

  return (
    <FormGroup>
      <SiteLinks
        type="splashImage"
        selectedModuleOption={selectedModuleOption}
        urlOnChange={urlOnChange}
        listBackButtonOnClick={listBackButtonOnClick}
        search={search}
        searchOnChange={searchOnChange}
        currentUrlOptions={currentUrlOptions}
        handleOnListClicked={handleOnListClicked}
        filteredOptions={filteredOptions}
        nestedMenu={nestedMenu}
        setShowOptions={setShowOptions}
        showOptions={showOptions}
        splashImage={slide}
      />
      <FormHelperText>{t('labels.themes.selectOrEnterUrlForButton')}</FormHelperText>
    </FormGroup>
  )
}